require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./alumni-clbres-0-10-1.json") })
        }
      }, "path---alumni-clbres-0-10-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---alumni-clbres-0-10-1!./.cache/json/alumni-clbres-0-10-1.json
// module id = 325
// module chunks = 231608221292675